export function ProgressBar({ value, className = "", showLabel = true }) {
  const v = Math.max(0, Math.min(100, value || 0));
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative h-2 flex-1 overflow-hidden rounded-full bg-white/10">
        <div
          className="gold-gradient absolute inset-y-0 left-0 rounded-full transition-[width] duration-500"
          style={{ width: `${v}%` }}
        />
      </div>
      {showLabel && (
        <span className="w-11 text-right font-heading text-sm font-semibold tabular-nums text-[#f7f3ec]">
          {v}%
        </span>
      )}
    </div>
  );
}
